import DOMPurify from "dompurify";

const ALLOWED_TAGS = [
  "p",
  "br",
  "strong",
  "em",
  "u",
  "s",
  "mark",
  "sub",
  "sup",
  "h1",
  "h2",
  "h3",
  "blockquote",
  "hr",
  "ul",
  "ol",
  "li",
  "a",
  "img",
];

const TEXT_ALIGN =
  /(?:^|;)\s*text-align:\s*(left|center|right|justify)\s*(?:;|$)/i;

/** Mirrors the server's announcement allow-list; of inline styles only alignment survives. */
export function sanitizeAnnouncementHtml(html: string): string {
  const fragment = DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR: ["href", "target", "rel", "src", "alt", "style"],
    RETURN_DOM_FRAGMENT: true,
  });

  for (const element of fragment.querySelectorAll("[style]")) {
    const align = TEXT_ALIGN.exec(element.getAttribute("style") ?? "")?.[1];
    if (align) {
      element.setAttribute("style", `text-align: ${align.toLowerCase()}`);
    } else {
      element.removeAttribute("style");
    }
  }

  const container = document.createElement("div");
  container.append(fragment);
  return container.innerHTML;
}
